import React from "react";
import { css, Global } from "@emotion/react";

const style = css`
  @import url("https://fonts.googleapis.com/earlyaccess/notosanskr.css");

  html {
    font-size: 62.5%;
    box-sizing: border-box;
    line-height: normal;
    font-family: "Pretendard", sans-serif;
    font-weight: 500;
    overflow-x: hidden;
  }

  body {
    width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
    font-size: 1.4rem;
    font-weight: 400;
    color: #111;
    padding: 0;
    margin: 0;

    &::-webkit-scrollbar {
      display: none;
      width: 1rem;
      height: 0.6rem;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #dcdcdc;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }

  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  iframe {
    width: 100dvw;
    height: 100dvh;
  }

  a {
    color: inherit;
    font-size: inherit;
    text-decoration: none;
  }

  *::placeholder {
    /* font-family: "Noto Sans KR", sans-serif; */
    font-family: "Pretendard", sans-serif;

    font-weight: 350;
    color: #909090;
  }

  button,
  a {
    color: #111;
    cursor: pointer;
    border: none;
    &:hover {
      transition: all 0.3s;
    }
  }

  ul,
  li {
    list-style: none;
  }

  button {
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: none;
    background: inherit;
  }

  textarea,
  input,
  select {
    outline: none;
    /* font-family: "Noto Sans KR", sans-serif; */
    font-family: "Pretendard", sans-serif;

    font-weight: 500;
    color: #212121;
    opacity: 1;

    &::-webkit-scrollbar {
      display: none;
      width: 1rem;
      height: 0.6rem;
    }

    &::placeholder {
      transition: all 0.3s;
    }

    &:focus {
      &::placeholder {
        opacity: 0;
      }
    }
  }

  input::-webkit-inner-spin-button {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
  }

  .ellipsis-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .ellipsis-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ellipsis-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .ellipsis-4 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .ant-drawer-content-wrapper {
    display: flex;
    justify-content: center;
    box-shadow: none !important;
  }
`;

const GlobalStyle = () => {
  return <Global styles={style} />;
};

export default GlobalStyle;
